<template>
  <div>
    <div class="action-key-container">
      <label class="tb-label">
        Hot Keys
      </label>

      <p>
        Trigger by pressing buttons or using keyboard shortcuts
      </p>

      <div class="action-keys">
        <action-key
          v-for="(action, index) in actions"
          :key="index"
          :action="action"
          :production_context="production_context"
          :data-test="`graphics-editor-ticker-${action.hotkey.toLowerCase()}`"
        />
      </div>
    </div>
    <data-list-settings v-if="hasSheetsData" :element="element" @value="updateElement" />
    <hr v-if="hasSheetsData" />
    <div class="tb-form-group">
      <label class="tb-label">
        Ticker Loop Spacing
      </label>

      <div class="flex items-center margin-bottom-sm">
        <div class="tb-radio margin-right-sm">
          <input
            type="radio"
            id="infinite"
            value="infinite"
            v-model="tickerSpacing"
            data-entity="producer-editor-tickerLoopSpacing"
            data-test="graphics-editor-ticker-infinite"
          />

          <label class="radio inline-radio" for="infinite">Infinite</label>
        </div>

        <div class="tb-radio">
          <input
            type="radio"
            id="spaced"
            value="spaced"
            v-model="tickerSpacing"
            data-entity="producer-editor-radioTickerSpacing"
            data-test="graphics-editor-ticker-spaced"
          >

          <label class="radio inline-radio" for="spaced">Spaced</label>
        </div>
      </div>
    </div>
    <div class="tb-form-group" role="group">
      <label for="marqueeSpeed" class="tb-label">Scroll Speed</label>
      <div class="flex items-center tb-range-slider__starEndFlexLayout">
        <div>Slow</div>

        <div class="tb-range-slider">
          <input
            id="marqueeSpeed"
            class="tb-range-slider__input tb-range-slider__input-reverse"
            v-model.number="scrollSpeed"
            type="range"
            name="scrollSpeed"
            min="500"
            max="4000"
            step="500"
            aria-label="Alternative slider input for Marquee Speed"
            data-entity="producer-editor-tickerScrollSpeed"
            data-test="graphics-editor-ticker-scrollSpeed"
          />
        </div>
        <div>Fast</div>
      </div>
    </div>

    <div class="tb-checkbox">
      <input
        type="checkbox"
        id="marqueeReverse"
        v-model="reverse"
        data-entity="producer-editor-toggleTickerDirection"
        data-test="graphics-editor-ticker-reverse"
      />

      <label class="checkbox" for="marqueeReverse">Reverse Scroll Direction</label>
    </div>

    <hr />
    <shape-settings :element="element" :graphic_fields="graphic_fields" @value="updateElement" />
  </div>
</template>

<script>
import ShapeSettings from '../shape/ShapeSettings.vue';
import DataListSettings from '../data/DataListSettings.vue';
import ActionKey from '../../../panel-editor/hotkeys/ActionKey.vue';

export default {
  props: {
  element: {
    required: true,
  },

  graphic_fields: {
    required: true,
  },

  production_context: {
    required: true,
  },
},

  components: {
    ShapeSettings,
    DataListSettings,
    ActionKey,
  },

  computed: {
    hasSheetsData() {
      return this.element.data?.providerType === 'sheet-data';
    },
    reverse: {
      get() {
        return this.elementFields?.reverse ?? this.element.reverse ?? false;
      },

      set(value) {
        this.updateField('reverse', value);
      },
    },
    scrollSpeed: {
      get() {
        return this.elementFields?.speed ?? this.element.speed ?? 2000;
      },

      set(value) {
        this.updateField('speed', value);
      },
    },
    tickerSpacing: {
      get() {
        return this.elementFields?.tickerSpacing ?? this.element.tickerSpacing ?? 'infinite';
      },

      set(value) {
        this.updateField('tickerSpacing', value);
      },
    },
    elementFields() {
      return this.graphic_fields[this.element.id];
    },
    actions() {
      return [
        {
          hotkey: 'P',
          display: 'Play/Pause',
          description: 'Use this hotkey to pause the ticker',
          value: 'play/pause',
          type: 'marquee',
          elementId: this.element.id,
        },
      ];
    },
  },

  methods: {
    updateElement(key, value) {
      this.$emit('value', key, value);
    },
    updateField(field, value) {
      this.$emit('value', { field, value });
    },
  },

};

</script>
